import { registerPlugin } from '@capacitor/core';
const AndroidSystemBars = registerPlugin('AndroidSystemBars', {
    web: () => import('./web').then((m) => new m.AndroidSystemBarsWeb()),
});
export * from './definitions';
export { AndroidSystemBars };
//# sourceMappingURL=index.js.map